import React from "react";
import { useTranslation } from "react-i18next";
import { SelectList } from "../selectList";
import { Props } from "./types";
import styles from "./styles.scss";

const formats = ["dd/MM/yyyy", "MM/dd/yyyy", "yyyy-MM-dd", "dd-MM-yyyy"];

function DateFormatForm(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.dateFormatForm}>
      <SelectList
        placeholder={t("preferences.dateFormatForm.placeholder")}
        selectedOptions={
          props.selectedDateFormat
            ? [
                {
                  id: props.selectedDateFormat,
                  name: props.selectedDateFormat.toUpperCase(),
                },
              ]
            : []
        }
        options={formats.map((format) => ({
          id: format,
          name: format.toUpperCase(),
        }))}
        selectItem={(options) =>
          options.length > 0 &&
          props.selectDateFormat(options[options.length - 1].id)
        }
      />
    </div>
  );
}

export { DateFormatForm };
